import { Color, Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import GraphHoverCardSelfieImage from 'dashboard/components/GraphHoverCardSelfieImage';
import { UppercaseLabel } from 'dashboard/components/Typography';
import {
  THRESHOLD_MATCH_IMAGE,
  THRESHOLD_VERY_HIGH_IMAGE,
} from 'dashboard/lib/constants/similarity-selfie';
import { HydratedImageBackgroundSim } from 'dashboard/models/graph-hydration';
import Sticker, { LabelBackgrounds } from 'design-system/components/Sticker';

const SectionTitle = styled(UppercaseLabel)`
  color: ${Color.CoreSlate900};
`;

const Spacer = styled.div`
  height: ${Spacing[4]};
`;

const SideBySideContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: ${Spacing[2]};
`;

interface GraphHoverCardImageBackgroundSimilarityProps {
  hydratedImageBackgroundSimilarity: HydratedImageBackgroundSim;
}

const GraphHoverCardImageBackgroundSimilarity = ({
  hydratedImageBackgroundSimilarity,
}: GraphHoverCardImageBackgroundSimilarityProps) => {
  const serverHydratedImageBackgroundSimilarity = hydratedImageBackgroundSimilarity.hydrationData;
  const {
    account1: { id: account1Id, images: account1Selfies },
    account2: { id: account2Id, images: account2Selfies },
    similarityScore,
  } = serverHydratedImageBackgroundSimilarity.details;
  const {
    text: similarityScoreText,
    color: similarityScoreColor,
  }: { text: string; color: LabelBackgrounds } =
    similarityScore >= THRESHOLD_MATCH_IMAGE
      ? {
          text: 'Likely Match',
          color: 'red',
        }
      : similarityScore > THRESHOLD_VERY_HIGH_IMAGE
        ? {
            text: 'Very High',
            color: 'pink',
          }
        : {
            text: 'High',
            color: 'yellow',
          };
  return (
    <>
      <SectionTitle>
        Selfie Similarity (Image): {hydratedImageBackgroundSimilarity.hydrationData['display-name']}
      </SectionTitle>
      <Sticker variant={similarityScoreColor}>{similarityScoreText}</Sticker>
      <Spacer />
      <SideBySideContainer>
        <a href={`/dashboard/accounts/${account1Id}`}>
          {account1Selfies && account1Selfies.length > 0 ? (
            <GraphHoverCardSelfieImage selfieFile={account1Selfies[0]} />
          ) : null}
        </a>
        <a href={`/dashboard/accounts/${account2Id}`}>
          {account2Selfies && account2Selfies.length > 0 ? (
            <GraphHoverCardSelfieImage selfieFile={account2Selfies[0]} />
          ) : null}
        </a>
      </SideBySideContainer>
    </>
  );
};

export default GraphHoverCardImageBackgroundSimilarity;
// Similarity score mapping to labels
